import { Radio } from 'antd';
import PropTypes from 'prop-types';
import styles from './radio-card.module.scss';

/**
 * RadioGroup
 *
 * Renders a group of radio buttons as cards.
 *
 * @param {Object} props - Component properties
 * @param {Array<Object>} props.options - Array of option objects for the radio group
 * @param {string|number} props.options[].value - Value of the radio option
 * @param {string} props.options[].label - Label for the radio option
 * @param {string} [props.options[].description] - Description for the radio option
 * @param {string|number} props.value - Currently selected value
 * @param {function} props.setValue - Function to update the selected value
 */
export const RadioGroup = ({ options, value, setValue, style }) => {
  return (
    <Radio.Group
      block
      buttonStyle="solid"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      style={style}
      className={styles.radioGroup}
      options={options.map((stage) => ({
        value: stage.value,
        label: <RadioCard value={stage.value} label={stage.label} description={stage.description} />,
      }))}
    />
  );
};

RadioGroup.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
      description: PropTypes.string,
    })
  ).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  setValue: PropTypes.func.isRequired,
};

/**
 * RadioCard
 *
 * Renders a single radio card with label and description.
 *
 * @param {Object} props - Component properties
 * @param {string|number} props.value - Value of the radio card
 * @param {string} props.label - Label for the radio card
 * @param {string} [props.description] - Description for the radio card
 */
const RadioCard = ({ value, label, description }) => {
  return (
    <div key={value} className={styles.stageItem}>
      <div className={styles.stageHeader}>
        <p className={styles.stageTitle}>{label}</p>
      </div>
      <p className={`${styles.stageDescription} text-dark-blue-50`}>{description}</p>
    </div>
  );
};

RadioCard.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  description: PropTypes.string,
};
